import { render } from "./HeaderPracticeResults.vue?vue&type=template&id=2af45d8c&scoped=true"
import script from "./HeaderPracticeResults.vue?vue&type=script&lang=js"
export * from "./HeaderPracticeResults.vue?vue&type=script&lang=js"

import "@/css/components/c-header-practice-results.css?vue&type=style&index=0&id=2af45d8c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af45d8c"]])

export default __exports__